// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"95":"formulario-de-pedido-cadastro","274":"Home"}[chunkId] + "." + {"95":"98b75cf5","274":"e279b29f"}[chunkId] + ".css";
};